import { de, enUS, es, fr, it, Locale } from 'date-fns/locale'

export function getLocalFromLanguage(): Locale {
    const language: string | null = localStorage.getItem('i18nextLng')
    switch (language) {
        case 'fr':
            return fr
        case 'en':
            return enUS
        case 'es':
            return es
        case 'de':
            return de
        case 'it':
            return it
        case 'ar':
            return fr
        default:
            return enUS
    }
}

export function getTextFromLanguage(): string {
    const language: string | null = localStorage.getItem('i18nextLng')
    switch (language) {
        case 'fr':
            return 'fr'
        case 'en':
            return 'en'
        case 'es':
            return 'es'
        case 'de':
            return 'de'
        case 'it':
            return 'it'
        case 'ar':
            return 'fr'
        default:
            return 'en'
    }
}
